import type {
    ComponentType,
    FC
} from "react";
import type ICarouselPauseProps from "./type";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import type {
    CarouselPartContentProps
} from "../../type";
import {
    Pause as PauseIcon,
    Play as PlayIcon
} from "lucide-react-native";
import {
    withCarouselContext
} from "../../context";
import CarouselControl from "../../internal/control";

const CarouselPauseContent: FC<CarouselPartContentProps<ICarouselPauseProps>> = ({
    "aria-label": ariaLabel,
    borderRadius,
    customTheme,
    context,
    style
}) => {
    const {
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    if(!context.isAutoplayEnabled) {
        return null;
    }

    return <CarouselControl
        label={ariaLabel ?? localize(context.isAutoplayPlaying ? "pause-autoplay" : "start-autoplay")}
        isOverlaid={context.controlsPlacement === "inside"}
        customTheme={customTheme ?? context.customTheme}
        isTransitioned={context.isAutoplayPlaying}
        onPress={context.handleTogglePlay}
        borderRadius={borderRadius}
        size={context.size}
        fromIcon={PlayIcon}
        toIcon={PauseIcon}
        style={style}
    />;
};

const CarouselPause: ComponentType<ICarouselPauseProps> = withCarouselContext("pause", CarouselPauseContent);
export default CarouselPause;
